import { create } from "zustand";
import { Highlight } from "../types";

interface HighlightStore {
  highlights: Highlight[];
  loading: boolean;
  error: string | null;

  setHighlights: (highlights: Highlight[]) => void;
  addHighlight: (highlight: Highlight) => void;
  removeHighlight: (id: string) => void;
  updateHighlight: (highlight: Highlight) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

export const useHighlightStore = create<HighlightStore>((set: any) => ({
  highlights: [],
  loading: false,
  error: null,

  setHighlights: (highlights: Highlight[]) => set({ highlights, error: null }),
  addHighlight: (highlight: Highlight) =>
    set((state: HighlightStore) => ({
      highlights: [...state.highlights, highlight],
    })),
  // Soft-delete (tombstone) rather than physically removing: consumers already
  // skip attrs.isDeleted === "true" (buildDecorations, hostBridge.activeHighlights),
  // and keeping the tombstone lets a delete PROPAGATE and STICK across Yjs
  // collaborators — a hard removal would just be an absence another peer's copy
  // could resurrect (see src/collab/highlightsBridge.ts).
  removeHighlight: (id: string) =>
    set((state: HighlightStore) => ({
      highlights: state.highlights.map((h: Highlight) =>
        h.id === id ? { ...h, attrs: { ...h.attrs, isDeleted: "true" } } : h
      ),
    })),
  updateHighlight: (highlight: Highlight) =>
    set((state: HighlightStore) => ({
      highlights: state.highlights.map((h: Highlight) => (h.id === highlight.id ? highlight : h)),
    })),
  setLoading: (loading: boolean) => set({ loading }),
  setError: (error: string | null) => set({ error }),
  clear: () => set({ highlights: [], error: null }),
}));
